const ns = "app/admin";

/**
 * Flush a root-level reducer
 * @type {string}
 */
export const FLUSH = `${ns}/__FLUSH__`;

export default {
  FLUSH
};
